(function () {
  'use strict';

  angular.toFixedNoRounding = (numberToConvert, decimalPlaces) => {
    if (!numberToConvert) {
      return '0.00';
    }

    const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + decimalPlaces + "})?", "g");
    const a = numberToConvert.toString().match(reg)[0];
    const dot = a.indexOf(".");
    if (dot === -1) {
      return a + "." + "0".repeat(decimalPlaces);
    }
    const b = decimalPlaces - (a.length - dot) + 1;
    return b > 0 ? (a + "0".repeat(b)) : a;
  }

  angular.calculateExTaxTotal = (sellPrice, fuel, surchargeTotal) => {
    const total = (Number(sellPrice) + Number(fuel) + Number(surchargeTotal));
    return total.toFixed(2);
  }

  angular.calculateTax = (exTaxTotal, taxPercent) => {
    const total = ((Number(exTaxTotal) * Number(taxPercent)) / 100);
    return total.toFixed(2);
  }

  angular.calculateIncludingTaxTotal = (exTaxTotal, tax) => {
    const total = (Number(exTaxTotal) + Number(tax));
    return total.toFixed(2);
  }

  angular.calculateChargeableWeight = (packages) => {
    let totalWeight = 0;
    packages.forEach(pkg => {
      totalWeight += Number(pkg.weight);
    });
    return totalWeight.toFixed(2)
  }

  angular.calculateMarginPercentageValue = (runningTotal, marginFixValue, marginPercentageValue) => {
    const total = (Number(runningTotal) + Number(marginFixValue)) * Number(marginPercentageValue) / 100;
    return math.bignumber(total);
  }

  angular.calculateMargin = (marginFixedValue, marginPercentageValue) => {
    const total = Number(marginFixedValue) + Number(marginPercentageValue);
    return math.bignumber(total);
  }

  angular.calculateFuelPercentageValue = (baseRate, fuelFixValue, fuelLevyPercentage) => {
    const nBaseRate = Number(baseRate);
    const nFuelFixValue = Number(fuelFixValue);
    const nFuelLevyPercentage = Number(fuelLevyPercentage);
    const total = ((nBaseRate + nFuelFixValue) * nFuelLevyPercentage) / 100;
    return math.bignumber(total);
  }

  angular.calculateFuel = (fuelPercentageValue, fuelFixValue) => {
    const total = Number(fuelPercentageValue) + Number(fuelFixValue);
    return math.bignumber(total);
  }

  angular.calculateRunningTotal = (baseRate, margin, fuelLevy) => {
    const total = (Number(baseRate) + Number(fuelLevy) + Number(margin));
    return total.toFixed(2);
  }

  angular.calculateCommissionPercentageValue = (runningTotal, commissionPercentage) => {
    const total = ((Number(runningTotal) * Number(commissionPercentage)) / 100);
    return total.toFixed(2);
  }
})(); 



// WEBPACK FOOTER //
// ./js/consts/bbaMath.js